import { Injectable } from '@angular/core';
import { TrackingService } from '@app/analytics/services/tracking.service';
import { FeedCard } from '@vestiaire/api-sdk-angular';
import { TagContainer } from '@app/analytics/models/container';
import { Event } from '@app/analytics/models/event';
import { IHideRecommended } from '../components/feed-suggestions/feed-suggestions.component';

@Injectable({
  providedIn: 'root'
})
export class FeedTrackingService {
  constructor(private trackingService: TrackingService) {}

  // click on picture or see-profile button in both suggested new-ins/price-drop and recommended profiles list
  trackSeeProfile(card: FeedCard, emitter: string, profilId?: string, profile_algo?: string) {
    const elementName = (emitter === 'button' && 'see profile') || (emitter === 'link' && 'profile');
    let event;

    if (profilId) {
      event = baseEventFactory(card, { elementName, profil: profilId, profile_algo });
    } else {
      event = baseEventFactory(card, { elementName });
    }

    this.trackingService.send(event);
  }

  // click on follow-button in suggested new-ins/price drop
  trackFollowButtonClick(card: FeedCard, profile_algo: string) {
    const elementName = 'follow';
    const event = baseEventFactory(card, { elementName, profile_algo });

    this.trackingService.send(event);
  }

  // click on follow-button in recommended profiles list
  trackRecommendedFollowButtonClick(card: FeedCard, profilId: string, profile_algo: string) {
    const elementName = 'follow';
    const dimensionType = card.cardType === 'recommended-profiles' ? 'recommended' : 'similar';
    const customPayload = { elementName, dimensionType, profilId, profile_algo };
    const event = baseEventFactory(card, customPayload);

    this.trackingService.send(event);
  }

  // click cross to close one profile in list of recommendations
  trackRecommendedHideClick(card: FeedCard, idPosition: IHideRecommended) {
    const elementName = 'close';
    const dimensionType = card.cardType === 'recommended-profiles' ? 'recommended' : 'similar';
    const profilId = idPosition.profileId;
    const position = idPosition.position;
    const profile_algo = idPosition.trackingKey;
    const customPayload = { elementName, dimensionType, profilId, position, profile_algo };
    const event = baseEventFactory(card, customPayload);

    this.trackingService.send(event);
  }

  // click on product in new-ins and price drop cards
  trackProductClick(card: FeedCard, productId: string, position: number) {
    const elementName = 'product';
    const product_id = productId;
    const event = baseEventFactory(card, { elementName, product_id });

    this.trackingService.send(event);
  }

  // click on see more product for new-ins and price drop cards
  trackSeeMoreProductClick(card: FeedCard, profilId: string) {
    const elementName = 'see more products';
    const event = baseEventFactory(card, { elementName, profilId });

    this.trackingService.send(event);
  }

  // click on like icon for products
  trackLikeClick(card: FeedCard, productId: string, position: number, isLiked: boolean) {
    const elementName = isLiked ? 'like' : 'unlike';
    const product_id = productId;
    const event = baseEventFactory(card, { elementName, product_id });

    this.trackingService.send(event);
  }
}

// Utils
function baseEventFactory(card: FeedCard, customPayload: Object): Event {
  const defaultPayload = {
    event: 'clickFeed',
    cardType: card.cardType,
    dimensionType: card.actor.isFollowed ? 'follow' : 'recommendation',
    profilId: card.actor.describes.id
  };

  return {
    type: 'event',
    container: TagContainer.Analytics,
    payload: { ...defaultPayload, ...customPayload }
  };
}
